import { useT } from './runtime';

/** Native names — how a speaker finds their own language. Never translated. */
const NATIVE_NAMES: Record<string, string> = {
  en: 'English',
  hi: 'हिन्दी',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  pt: 'Português',
  ar: 'العربية',
};

/**
 * The customer's language switcher (DEC-053). Renders ONLY when more than one
 * locale is offerable — an English-only deployment shows nothing rather than a
 * single-item menu. Plain buttons, thumb-sized, no dropdown: on the anxious
 * one-shot mobile journey, the choice must be one visible tap, not a hunt
 * through a menu. Each label is the language's own native name, because that is
 * the one string its speaker can always read.
 */
export function LocaleSwitcher(): JSX.Element | null {
  // VC-12: the session's offer (Arabic only when the session's pack names it)
  const { locale, setLocale, offered: locales } = useT();
  if (locales.length < 2) return null;

  return (
    <div className="locale-switcher" role="group" aria-label="Language / भाषा">
      {locales.map((code) => (
        <button
          key={code}
          type="button"
          lang={code}
          className="locale-choice"
          aria-pressed={locale === code}
          onClick={() => setLocale(code)}
        >
          {NATIVE_NAMES[code] ?? code}
        </button>
      ))}
    </div>
  );
}
